import { ShieldCheck } from 'lucide-react';
import { BrandLogo } from '../components/BrandLogo';
import { Button } from '../components/ui/Button';
import { useAuth } from '../lib/auth';

export function SignInPage() {
  const { login } = useAuth();

  return (
    <main className="flex min-h-screen items-center justify-center bg-bone px-4 py-12 text-ink">
      <section className="w-full max-w-md rounded-sm border border-ink/15 bg-ivory p-8 shadow-soft sm:p-10">
        <BrandLogo variant="wordmark" className="w-[120px]" />
        <div className="mt-12 border-t border-ink/15 pt-8">
          <div className="mb-5 flex h-11 w-11 items-center justify-center rounded-sm bg-black text-ivory">
            <ShieldCheck className="h-5 w-5" />
          </div>
          <p className="text-xs font-semibold uppercase tracking-[0.18em] text-ink/70">Private access</p>
          <h1 className="mt-3 text-2xl font-semibold">Admin portal</h1>
          <p className="mt-2 text-sm leading-6 text-ink/70">Private Storyly operations access for client, invoice, and platform controls.</p>
          <Button className="mt-7 w-full" onClick={() => void login()}>
            Sign in
          </Button>
        </div>
      </section>
    </main>
  );
}
